/**
 * Dezente, monochrome Grafikelemente aus der Liftwelt: Diagonalschraffuren,
 * Schachtlinien (Führungsschienen), Etagenlinien, eine Kabinenmarke und ein
 * Richtungswinkel. Reine Linienarbeit, keine gefüllten Figuren.
 * Immer hinter dem Inhalt, nie klickbar.
 */

type DecorProps = { className?: string };
type Tone = { light?: boolean };

/** Diagonale Hairline-Schraffur mit weichem Ausblenden. */
export function DecorHatch({
  className = "",
  fade = "right",
}: DecorProps & { fade?: "right" | "left" | "top" | "bottom" }) {
  const maskDir =
    fade === "right" ? "to left" : fade === "left" ? "to right" : fade === "top" ? "to bottom" : "to top";
  return (
    <span
      aria-hidden
      className={`pointer-events-none absolute deco-hatch ${className}`}
      style={{
        maskImage: `linear-gradient(${maskDir}, transparent 0%, black 55%)`,
        WebkitMaskImage: `linear-gradient(${maskDir}, transparent 0%, black 55%)`,
      }}
    />
  );
}

/** Einzelne, lange Diagonallinie quer durch eine Sektion. */
export function DecorDiagonal({ className = "" }: DecorProps) {
  return <span aria-hidden className={`pointer-events-none absolute deco-diagonal ${className}`} />;
}

/**
 * Zwei parallele senkrechte Hairlines - wie die Führungsschienen eines
 * Liftschachts. Rein statisch, ohne Bewegung.
 */
export function DecorShaft({ className = "", light = false }: DecorProps & Tone) {
  const line = light ? "deco-rail-light" : "deco-rail";
  return (
    <span aria-hidden className={`pointer-events-none absolute deco-shaft ${className}`}>
      <span className={`absolute inset-y-0 left-0 w-px ${line}`} />
      <span className={`absolute inset-y-0 right-0 w-px ${line}`} />
    </span>
  );
}

/** Gestapelte kurze Horizontalen mit Stockwerksmarken - wie eine Etagenanzeige. */
export function DecorFloors({
  className = "",
  count = 6,
  light = false,
}: DecorProps & Tone & { count?: number }) {
  return (
    <span aria-hidden className={`pointer-events-none absolute flex flex-col justify-between ${className}`}>
      {Array.from({ length: count }).map((_, i) => (
        <span key={i} className="flex items-center gap-2">
          <span className={`h-px flex-1 ${light ? "deco-floor-light" : "deco-floor"}`} />
          <span className={`h-px w-3 ${light ? "deco-floor-light" : "deco-floor"} opacity-70`} />
        </span>
      ))}
    </span>
  );
}

